import React from "react";
import "./style.css";
import axios from 'axios';
import { CourseReview } from "../CourseReview/CourseReview";

export const CourseReviews = ({
  reviews_product_id,
  num_reviews,
  language
}) => {

  const [reviews, setReviews] = React.useState([]);
  const [numberLoaded, setNumberLoaded] = React.useState(0);
  const [current_page, setCurrentPage] = React.useState(0);
  const [loading_comments, setLoadingComments] = React.useState(false);

  const reviews_per_page = 15;

  const translations = {
    "more": {
      "en": "View more reviews",
      "es": "Ver más reseñas",
      "pt": "Ver mais opiniões",
      "fr": "Voir plus de notes",
      "ru": "Посмотреть больше отзывов"
    },
    "de": {
      "en": "of",
      "es": "de",
      "pt": "de",
      "fr": "sur",
      "ru": "из"
    },
  };

  const loadMoreComments = () => {

    if (loading_comments) {
      console.info("Still loading comments...");
      return false;
    }

    setLoadingComments(true);

    axios
      .get(`https://www.10masters.com/course_reviews/${reviews_product_id}/${reviews_per_page}/${current_page}/${language}/`)
      .then(res => {
        setReviews([...reviews, ...res.data]);
        let loaded = res.data.length;

        // If it includes the last comment, do not count it as comment
        if ( res.data[res.data.length-1].last_comment == true)
          loaded--;

        setNumberLoaded(numberLoaded + loaded);
        setLoadingComments(false);
      })
      .catch(err => {
        console.log(err);
        setLoadingComments(false);
      });

    setCurrentPage(current_page + 1);

  };

  React.useEffect(() => {

    loadMoreComments();

  }, []);

  return (

    <div className="course_reviews_list">

      {reviews.map((review) => (

        review.last_comment != true &&
        <CourseReview
          key={review.id}
          name={review.name}
          avatar={review.avatar}
          points={review.score}
          text={review.body ? review.body : ''}
          language={language}
          instagram={review.instagram}
        />

      ))}

      {
        numberLoaded < num_reviews && !loading_comments &&
        <div className="load_more_reviews" onClick={loadMoreComments}>{translations["more"][language]}</div>
      }
      {
        loading_comments ?
          <div className="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF5A5D" className="loading_comments_rotate bi bi-hourglass" viewBox="0 0 16 16">
              <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702c0 .7-.478 1.235-1.011 1.491A3.5 3.5 0 0 0 4.5 13v1h7v-1a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351v-.702c0-.7.478-1.235 1.011-1.491A3.5 3.5 0 0 0 11.5 3V2h-7z" />
            </svg>
          </div>
          : <></>
      }

      <div className="num_reviews_bar">
        <div className="num_reviews_inner_bar" style={{ "width": `${(numberLoaded / num_reviews) * 100}%` }}></div>
      </div>

      <div className="course_reviews_current_total">{numberLoaded} {translations["de"][language]} {num_reviews}</div>

    </div>

  );
};